import React from 'react';
import { Link, animateScroll as scroll } from "react-scroll";

const ValueProp = props => {

  return (
    <section className="value-prop">
      <div className="value-prop-content">
        <div className="main-message">
          <h1>Your creativity deserves to be rewarded.</h1>
          <p className="main-subtitle">
            Pipory in an online social media platform that is designed to reward all 
            forms of creativity ranging from poetry and art to photography and memes.
          </p>
          <Link
              activeClass="active"
              to="CTA"
              spy={scroll}
              smooth={true}
              offset={-70}
              duration={500}
              className="button"
          >Request Early Access</Link>
        </div>
        <div className="main-photo"></div>
      </div>
    </section>
  )
};

export default ValueProp;
